module.exports = __webpack_public_path__ + "static/media/Apr3-S18.d4484279.png";